import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
//page links          
import Header from '../master_root/header';
import './task.css';
import Footer from '../master_root/footer';
// Icons
import { MdOutlinePayments } from "react-icons/md";
import { VscSmiley } from "react-icons/vsc";
import { GetAgoTime } from '../components/getAgoTime';
import { CiBookmarkCheck, CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoBusinessOutline, IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
export default function JobTask() {
  const [loading, setLoading] = useState(true);
  const [Skillscategories, setSkillscategories] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState("0");
  const [selectedjobcategories, setSelectedjobcategories] = useState("0");
  const [products, setProducts] = useState([]);
  const [Jobtasks, setJobtasks] = useState([]);
  const [CompanysUi, setCompanysUi] = useState([]);
  const [jobcategories, setJobcategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [experience, setExperience] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [loginName, setLoginName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [viewMode, setViewMode] = useState("skills");
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };
  // Fetch Skill Categories
  useEffect(() => {
    const fetchSkillscategoriesData = async () => {
      try {
        setIsLoading(true);
        let jq;
        if (selectedSkill === "0") {
          jq = query(collection(db, "postdata"), where("visibility", "==", true));
        } else {
          jq = query(
            collection(db, "postdata"),
            where("skillsId", "==", selectedSkill),
            where("visibility", "==", true)
          );
        }

        const querySnapshot = await getDocs(jq);
        const skillsCountMap = {};
        const skillIdsSet = new Set();

        querySnapshot.forEach(doc => {
          const skillId = doc.data().skillsId;
          if (skillId) {
            skillIdsSet.add(skillId);
            skillsCountMap[skillId] = (skillsCountMap[skillId] || 0) + 1;
          }
        });

        const skillCategoriesPromises = Array.from(skillIdsSet).map(async skillId => {
          const q = query(collection(db, "skills_categories"), where("skillsId", "==", skillId));
          const skillSnap = await getDocs(q);
          const skillDoc = skillSnap.docs[0];

          return skillDoc ? {
            id: skillDoc.id,
            ...skillDoc.data(),
            totalPosts: formatCount(skillsCountMap[skillId]) || 0
          } : null;
        });

        const skillscategoriesList = (await Promise.all(skillCategoriesPromises)).filter(Boolean);
        setSkillscategories(skillscategoriesList);
      } catch (error) {
        console.error("Error fetching skill categories:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSkillscategoriesData();
  }, [selectedSkill]);

  const formatCount = (num) => {
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + "K";
    return num.toString();
  };

  const changeskills = (skillsId) => {
    if (skillsId === "0") {
      setSelectedSkill("0");
      setSelectedjobcategories("0");

      setTimeout(function () {
        fetchJobtasks("0");
      }, 2000);


    } else {
      setSelectedjobcategories("0");
      setSelectedSkill(skillsId);
      fetchjobcategory(skillsId);
      fetchJobtasks("0");
    }
  };

  const fetchjobcategory = async (skillsId) => {
    try {
      const q = query(
        collection(db, "postdata"),
        where("skillsId", "==", skillsId),
        where("visibility", "==", true)
      );
      const querySnapshot = await getDocs(q);
      const jobCategoryMap = new Map();
      querySnapshot.forEach(doc => {
        const data = doc.data();
        const jobcategoryId = data.jobcategoryId;
        const jobcategoryName = data.jobcategories;

        if (jobcategoryId) {
          if (!jobCategoryMap.has(jobcategoryId)) {
            jobCategoryMap.set(jobcategoryId, {
              jobcategoryId,
              jobcategories: jobcategoryName || "Unnamed",
              totalPosts: 1
            });
          } else {
            jobCategoryMap.get(jobcategoryId).totalPosts += 1;
          }
        }
      });
      const JobtasksList = Array.from(jobCategoryMap.values());
      setJobcategories(JobtasksList);
    } catch (error) {
      console.error("Error fetching Jobtasks:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchJobtasks("0");
  }, []);

  const fetchJobtasks = async (jobcategoryId) => {
    try {
      let q;
      if (selectedSkill === "0" && jobcategoryId === "0") {

        q = query(collection(db, "postdata"), where("visibility", "==", true));
      } else if (jobcategoryId !== "0") {

        setSelectedjobcategories(jobcategoryId);

        q = query(
          collection(db, "postdata"),
          where("jobcategoryId", "==", jobcategoryId),
          where("visibility", "==", true)
        );
      } else {

        q = query(
          collection(db, "postdata"),
          where("skillsId", "==", selectedSkill),
          where("visibility", "==", true)
        );
      }

      const querySnapshot = await getDocs(q);
      // Optional: Populate jobcategories again if viewing all
      if (selectedSkill === "0" && jobcategoryId === "0") {
        const jobCategoryMap = new Map();
        querySnapshot.forEach(doc => {
          const data = doc.data();
          const jobcategoryId = data.jobcategoryId;
          const jobcategoryName = data.jobcategories;

          if (jobcategoryId) {
            if (!jobCategoryMap.has(jobcategoryId)) {
              jobCategoryMap.set(jobcategoryId, {
                jobcategoryId,
                jobcategories: jobcategoryName || "Unnamed",
                totalPosts: 1
              });
            } else {
              jobCategoryMap.get(jobcategoryId).totalPosts += 1;
            }
          }
        });
        setJobcategories(Array.from(jobCategoryMap.values()));
      }

      const JobtasksList = await Promise.all(
        querySnapshot.docs.map(async doc => {
          const jobData = { id: doc.id, ...doc.data() };

          const cq = query(
            collection(db, "companys"),
            where("uid", "==", jobData.companysuid),
            where("status", "==", true)
          );
          const companysSnapshot = await getDocs(cq);
          const companyData = companysSnapshot.docs[0]?.data() || null;

          return {
            ...jobData,
            company: companyData
          };
        })
      );

      setJobtasks(JobtasksList);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching Jobtasks:", error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header />
      <div className='app_header_height'></div>

      <div className="container_roots">

        <Helmet>
          <title>Explore Job Tasks | EditorTask - Get Work Done Faster</title>
          <meta name="description" content="Discover a variety of job tasks on EditorTask. Find and complete tasks to earn rewards or get help with your own projects." />
          <meta name="keywords" content="job tasks, freelance work, EditorTask, get tasks, online tasks, remote jobs" />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Browse Job Tasks | EditorTask" />
          <meta property="og:description" content="Find job tasks to complete or post your own on EditorTask – your place to get things done." />
          <meta property="og:url" content="https://yourdomain.com/task" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        </Helmet>

        <div className="container_size">

          <div className='post-container'>
            <div className="contact-title">Explore Job Tasks | EditorTask - Get Work Done Faster</div>
          </div>

          <div className='Skillscategories-body'>
            <div className="categories-grid">
              {isLoading ? (
                <Lodinging />
              ) : (
                <>
                  <div
                    onClick={() => {
                      setSelectedSkill("0");
                      changeskills("0");
                    }}
                    className={`categories ${selectedSkill === "0" ? 'active' : ''}`}
                  >
                    <div className='title-text '
                      style={{ cursor: 'pointer' }}
                    >
                      All

                    </div>
                  </div>

                  {Skillscategories.map((skillscat, index) => (
                    <div onClick={() => changeskills(skillscat.skillsId)}
                      className={`categories ${selectedSkill === skillscat.skillsId ? 'active' : ''}`}
                      key={index}>
                      <div className='title-text'

                        style={{ cursor: 'pointer' }}
                      >
                        {skillscat.title} <a className='count-text'>({skillscat.totalPosts})</a>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
          <div className='post-container'>
            <div className='post_updates'>
              <div className='jobcategories-body'>
                {isLoading ? (
                  <Lodinging />
                ) : (
                  <>
                    {jobcategories.map((cat, index) => (
                      <div key={index} style={{ cursor: 'pointer' }} onClick={() => fetchJobtasks(cat.jobcategoryId)}
                        className={`jobcategoriestask ${selectedjobcategories === cat.jobcategoryId ? 'active' : ''}`}
                      >  <div className='category-content' >
                          <div className='title-text'>{cat.jobcategories}</div>
                          <a className='count-text'>({cat.totalPosts})</a>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            <div className='post_div'>
              <div className="Tasks-grid">
                {isLoading ? (
                  <Lodinging />
                ) : (
                  Jobtasks.map((Jobtask, index) => (
                    <div
                      key={index}
                      className="Tasks-items"                    >
                      {Jobtask.company && (
                        <div className="company-hiring" onClick={() => navigate(`/${Jobtask.slug}`)}>

                          <div className='hir-div'>
                            <div className="title-text">{Jobtask.jobcategories}</div>

                            <div className='hir-info-div'>
                              <b className='company'>{Jobtask.company.companyname}</b>
                              <div className='items-box'>
                                <FaStar className='items-rating' />
                                <a className='reviews'>
                                  {Jobtask.company.rating + " | " + Jobtask.company.reviws + " reviews"}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='hir-logo-div'>
                            <img
                              className="hir-logo-img"
                              src={Jobtask.company.logo}
                              alt="Logo"
                              onLoad={() => setLoading(false)}
                              onError={() => setLoading(false)} // also hides loader if there's an error
                              style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                            />
                          </div>
                        </div>
                      )}
                      <div className='job-info-body' onClick={() => navigate(`/${Jobtask.slug}`)}>
                        <div className='job-info'>

                          <table className='experience-table'>
                            <tr><td>
                              <RiSlideshowLine className='job_biz_icon' />
                            </td>
                              <td>
                              <a className='Jobtask-category-text'> {Jobtask.category.replace(/-/g, " ")}</a>
                              </td>
                            </tr>
                            <tr><td>
                              <LuBriefcaseBusiness className='job_biz_icon' />
                            </td>
                              <td>
                                <a> {Jobtask.experience}</a>
                              </td>
                            </tr>

                            <tr><td>
                              <MdOutlinePayments className='job_biz_icon' />
                            </td>
                                <td>
<a className="job_biz_text">
  {Jobtask.currency} <b>{Jobtask.budget}/- </b>{Jobtask.budgetpackage.replace(/-/g, " ")}
</a>
                            </td>
                            </tr>
                            <tr><td>
                              <CiLocationOn className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'>{Jobtask.city + ", " + Jobtask.state + " - " + Jobtask.country}</a>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div className='job-info'>
                          <table className='experience-table'>
                            <tr><td>
                              <IoDocumentTextOutline className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'> Greetings: {Jobtask.title}</a>
                              </td>
                            </tr>
                            <tr><td>
                              <BsPersonWorkspace className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'>{Jobtask.skills}</a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      {/* job-save-div */}
                      <div className='job-save-div'>
                        <div className='date-lable'>{GetAgoTime(Jobtask.date_time)}</div>

                        <div className='summarylistdiv'>
                          <div className='save_note' title='Save'>
                            <CiBookmark className='save_icon' />
                            <div className='save_text'>Save</div>
                          </div>
                        </div>
                      </div>

                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
      <Footer/>
    </div>
  );
}
